import { Box, CircularProgress } from '@mui/material';
import { bindHover, bindPopover } from 'material-ui-popup-state';
import HoverPopover from 'material-ui-popup-state/HoverPopover';
import { usePopupState } from 'material-ui-popup-state/hooks';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { DeviceV2 } from '../../../backendsdk';
import { formatDateTime } from '../../../utils/TimeFormatter';
import { RTLDirectionContext } from '../../Layout';
import { WellnessImage } from '../Overview/DeviceDetails/WellnessPanel';
import WellnessBox, { WELLNESS_TYPE_MAP } from './WellnessBox';

interface WellnessBoxProps {
    device: DeviceV2;
    wellnessType: 'in_cabin' | 'in_cabin_v1' | 'front_facing';
    wellnessId?: number;
    timestamp?: number;
    wellnessDetails: string;
}

const WellnessContainer: React.FC<WellnessBoxProps> = (props: WellnessBoxProps) => {
    const { t } = useTranslation();
    const isRTL = useContext(RTLDirectionContext);

    const popupState = usePopupState({
        variant: 'popover',
        popupId: 'wellness-popover',
    });

    return (
        <>
            <WellnessBox
                wellnessType={props.wellnessType}
                wellnessDetails={props.wellnessDetails}
                {...bindHover(popupState)}
            />
            <HoverPopover
                {...bindPopover(popupState)}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: isRTL ? 'right' : 'left',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: isRTL ? 'left' : 'right',
                }}
            >
                <Box
                    sx={{
                        p: 0.5,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'start',
                    }}
                >
                    {t(WELLNESS_TYPE_MAP[props.wellnessDetails])}
                    <Box style={{ width: '250px' }}>
                        {!props.wellnessId ? (
                            <CircularProgress size={24} />
                        ) : (
                            <WellnessImage wellnessType={props.wellnessType} wellnessId={props.wellnessId} />
                        )}
                    </Box>
                    {props.timestamp ? formatDateTime(props.timestamp) : null}
                </Box>
            </HoverPopover>
        </>
    );
};

export default WellnessContainer;
